export const url = {
  "/sys/dmgl/allDataList":true,
}
